import { http } from 'lib/services/http';
import { voiceBaseUrl } from 'constants/apiUrls';

const BASE_API_PATH = `${voiceBaseUrl}`;

export const getVoiceUser = (profileId: string) => {
  return http.get(`${BASE_API_PATH}/users/${profileId}/info`);
};

export const getVoiceUserPhoneNumbers = (profileId: string) => {
  return http.get(`${BASE_API_PATH}/users/${profileId}/phone-numbers`);
};

// TODO: figure out why this doesn't return anything.
// The local test account (agentzero) has a primary phone number
export const getVoiceUserPrimaryPhone = (profileId: string) => {
  return http.get(`${BASE_API_PATH}/users/${profileId}/phone/primary`);
};

export const updateVoiceUserPhoneNumber = (profileId: string, body) => {
  return http.put(`${BASE_API_PATH}/users/${profileId}/phone-numbers`, body);
};
